module.exports = __webpack_public_path__ + "static/media/gray-next-button.d070b7a8.svg";